import { hasClass } from '@/helpers/has'
import Velocity from 'velocity-animate'
import { ref } from '@vue/composition-api'

const activeTransitions = ref(0)
const transitionsDone = ref(true)
const footerLoaded = ref(false)

function beforeEnterFooter (el) {
  el.style.opacity = 0
  el.style.bottom = '-100px'
}

function enterFooter (el, done) {
  Velocity(
    el,
    { opacity: 0.9, bottom: '0px' },
    {
      complete: () => {
        done()
        footerLoaded.value = true
      }
    }
  )
}

function leaveFooter (el, done) {
  Velocity(
    el,
    { opacity: 0.01, bottom: '-100px' },
    {
      complete: () => {
        done()
        footerLoaded.value = false
      }
    }
  )
}

function beforeEnter (el) {
  let isPrimary = hasClass(el, 'primary-col')
  let isFirst = hasClass(el, 'first-item')
  let isLast = hasClass(el, 'last-item')
  el.style.opacity = 0
  if (isPrimary) {
    if (isFirst) el.style.top = '-300px'
    else el.style.left = '-300px'
  } else {
    if (isLast) el.style.bottom = '-300px'
    else el.style.right = '-300px'
  }
}

function enter (el, done) {
  let to = { opacity: 1 }
  let isPrimary = hasClass(el, 'primary-col')
  let isFirst = hasClass(el, 'first-item')
  let isLast = hasClass(el, 'last-item')
  if (isPrimary) {
    if (isFirst) to.top = '0px'
    else to.left = '0px'
  } else {
    if (isLast) to.bottom = '0px'
    else to.right = '0px'
  }
  Velocity(el, to, { complete: done })
}

function leave (el, done) {
  let to = { opacity: 0 }
  let isPrimary = hasClass(el, 'primary-col')
  let isFirst = hasClass(el, 'first-item')
  let isLast = hasClass(el, 'last-item')
  if (isPrimary) {
    if (isFirst) to.top = '-300px'
    else to.left = '-300px'
  } else {
    if (isLast) to.bottom = '-300px'
    else to.right = '-300px'
  }
  transitionsDone.value = false
  activeTransitions.value++
  Velocity(
    el,
    to,
    {
      complete: () => {
        done()
        activeTransitions.value--
        if (activeTransitions.value === 0) {
          transitionsDone.value = true
        }
      }
    }
  )
}

export {
  beforeEnterFooter,
  enterFooter,
  leaveFooter,
  beforeEnter,
  enter,
  leave,
  activeTransitions,
  transitionsDone,
  footerLoaded
}
